import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Row, Col } from "antd";
import { FaArrowUp } from "react-icons/fa";

gsap.registerPlugin(ScrollTrigger);

function Lables() {
  const ctxRef = useRef(null);

  useLayoutEffect(() => {
    // scope animations to this component
    const ctx = gsap.context(() => {
      // top marquee → right
      gsap.to(".main-animation-group", {
        xPercent: 30,
        scrub: 0.6, // numeric scrub gives smoother reverse behavior
        invalidateOnRefresh: true,
        scrollTrigger: {
          trigger: ".section-lables",
          start: "top bottom",
          end: "bottom top",
          scrub: 0.6,
          // markers: true, // <- enable while debugging
        },
      });

      // bottom marquee → left
      gsap.to(".main-animation-group1", {
        xPercent: -30,
        scrub: 0.6,
        invalidateOnRefresh: true,
        scrollTrigger: {
          trigger: ".section-lables",
          start: "top bottom",
          end: "bottom top",
          scrub: 0.6,
          // markers: true,
        },
      });
    });

    ctxRef.current = ctx;
    return () => ctx.revert(); // kills scrollTriggers + tweens when component unmounts
  }, []);

  const items = [
    "Brochure Design",
    "Cotton Print Design",
    "Labels Rools",
    "Custom Print Design",
    "Brochure Design",
    "Cotton Print Design",
    "Labels Rools",
    "Custom Print Design",
  ];
  // const items2 = [
  //   "Brochure Design",
  //   "Cotton Print Design",
  //   "Labels Rools",
  //   "Custom Print Design",
  //   "Brochure Design",
  //   "Cotton Print Design",
  //   "Labels Rools",
  //   "Custom Print Design",
  // ];

  return (
    <div
      className="section-lables h-[60vh] flex justify-center items-center overflow-hidden relative"
      /* optional: add ref if you need to scope to a particular node */
    >
      <Row gutter={[0, 60]} className="w-full">
        {/* Top row — rotation only on wrapper, inner UL has transform-none so GSAP can control translate cleanly */}
        {/* Top row */}
        <Col xs={24}>
          <div className="rotate-[5deg] -ml-[900px]">
            <ul className="main-animation-group transform-none flex whitespace-nowrap font-outfit text-[28px] bg-cover shadow-md py-6 rounded-lg will-change-transform">
              {items.concat(items).map((text, i) => (
                <li
                  key={`top-${i}-${text}`}
                  className="mx-12 font-custom text-[38px] flex items-center tracking-wide transition-transform hover:scale-110"
                >
                  {text}
                  <span className="ml-5 border text-[22px] p-2 border-black rounded-full bg-white shadow hover:bg-black hover:text-white transition">
                    <FaArrowUp />
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Col>

        {/* Bottom row */}
        <Col xs={24}>
          <div className="-rotate-[15deg] -ml-[1000px] extra-line">
            <ul className="main-animation-group1 transform-none flex whitespace-nowrap font-outfit text-[28px] bg-cover shadow-md py-6 rounded-lg will-change-transform">
              {items.concat(items).map((text, i) => (
                <li
                  key={`top-${i}-${text}`}
                  className="mx-12 font-custom text-[38px] flex items-center tracking-wide transition-transform hover:scale-110"
                >
                  {text}
                  <span className="ml-5 border text-[22px] p-2 border-black rounded-full bg-white shadow hover:bg-black hover:text-white transition">
                    <FaArrowUp />
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Lables;
